(function () {
    'use strict';

    angular.module("product")
        .controller('ProductLogApplyModalController', ProductLogApplyModalController);

    ProductLogApplyModalController.$inject = ['product', '$uibModalInstance', 'productDataSrvc', 'notificationSrvc', 'productMessagesConst', 'errorNotificationSrvc'];

    function ProductLogApplyModalController(product, $uibModalInstance, productDataSrvc, notificationSrvc, productMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.products = [];
        self.product = product;
        self.productData = {
            item: null
        };
        self.importData = {
            product: null
        };
        self.loading = false;

        self.ok = ok;
        self.cancel = cancel;
        self.onProductSearch = onProductSearch;
        self.onProductChange = onProductChange;

        activate();

        function activate() {
            getProducts();
        }

        function ok() {
            if (self.importData.product) {
                self.loading = true;

                productDataSrvc.applyProductLog({
                    pk: product.pk
                }, {
                    product: self.importData.product
                }).$promise.then(
                    function (response) {
                        self.loading = false;
                        notificationSrvc.notification("success", productMessagesConst.update);

                        $uibModalInstance.close(self.importData.product);
                    },
                    function (response) {
                        self.loading = false;
                        errorNotificationSrvc.displayErrors(response.data)
                    }
                );
            }
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function getProducts() {
            return productDataSrvc.optionsList().$promise.then(
                function (response) {
                    self.products = response.results;
                    return response;
                }
            )
        }

        function onProductSearch(params) {
            if (!params) {
                params = {};
            }
            return productDataSrvc.optionsList(
                params
            ).$promise;
        }

        function onProductChange(product) {

        }
    }
})();
